import firebase from 'firebase';

// Initialize Firebase
const config = {
    apiKey: "AIzaSyBtgTmaArP2cfIkeYFG803bthVGmXF7YTM",
    authDomain: "musd-course-catalog-prod.firebaseapp.com",
    databaseURL: "https://musd-course-catalog-prod.firebaseio.com",
    projectId: "musd-course-catalog-prod",
    storageBucket: "musd-course-catalog-prod.appspot.com",
    messagingSenderId: "121644704518",
    appId: "1:121644704518:web:e41117bc17e2bebd4e3487",
    measurementId: "G-K4LGWHTVB9"
}

if ( !firebase.apps.length ) {
	firebase.initializeApp( config );
}

export default firebase;
